import React from "react";
import PropTypes from "prop-types";
import Confirmation from  "@cloudpremise/portal_core/src/themes/mui/components/Modals/Confirmation";
import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from '@azure/msal-react';
import { loginRequest, getParam, Api, CaseModalState, Loader, getSessionId } from '@cloudpremise/portal_core';
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import Box from '@mui/material/Box';
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDModal from "@cloudpremise/portal_core/src/themes/mui/components/MDModal";
import Dropzone from 'react-dropzone';
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';

import { CardActionArea } from '@mui/material';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

import Config from "../../../../Config";
const cdnUrl = Config.getCdnUrl();

// Images
const kal = cdnUrl + "/assets/images/kal-visuals-square.jpg";

const UploadModal = (props) => {
    const { uploading } = props;
    let defaultState = {
        folder: null,
        errorMessage: null,
        files: [],
        ...props,
    };
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    function getHeading(){
        if(state.folder === null){
            return "Upload Files";
        }
        return "Upload Files to "+state.folder;
    }
    const handleFileUpload = (acceptedFiles) => {
        let files = [];
        acceptedFiles.forEach((file) => {
            files.push(file);
        });
        setState({
            files: files
        });
    }
    function onRemoveFile(index){
        let files = [];
        state.files.forEach((file, key) => {
            if(key !== index){
                files.push(file);
            }
        });
        setState({
            files: files
        });
    }
    function renderFile(file, index){
        return (
            <MDBox>
                <CardActionArea className="document-folder__heading" sx={{paddingTop: "8px !important", paddingBottom: "8px !important"}}>
                    <FileUploadOutlinedIcon />
                    <MDTypography variant="p" component="p" mb={1}>
                        {file.name}
                    </MDTypography>
                    <DeleteOutlinedIcon onClick={() => onRemoveFile(index)} />
                </CardActionArea>
            </MDBox>
        )
    }
    return (
        <MDModal
            open={props.open}
            footer={
                (
                    state.loading ?
                        <Loader color="info" />
                    :
                        <>
                            {
                                state.error && state.errorMessage !== null ?
                                    null
                                :
                                <>
                                    <MDButton key="cancel" variant="gradient" color="light" onClick={() => props.onCancel()} >
                                        Cancel
                                    </MDButton>
                                    <MDButton key="save" variant="gradient" color="info" disabled={(state.files.length === 0)} onClick={() => props.onSuccess(state.files)}>
                                        {
                                            uploading ?
                                                <Loader color="white" size={20} />
                                            :
                                                "Upload"
                                        }
                                    </MDButton>
                                </>
                            }
                        </>
                )
            }
            onClose={() => props.onCancel()}
            title={getHeading()}
            width="700px"
            maxWidth="700px"
        >
            <div className="slds-p-around_medium">
                <MDTypography mb={2}>Files types accepted are: pdf, jpg, gif, png and webp</MDTypography>
                <Dropzone onDrop={handleFileUpload}>
                    {({ getRootProps, getInputProps }) => (
                        <Box
                            {...getRootProps()}
                            sx={{
                                border: '2px dashed #ccc',
                                p: 5,
                                textAlign: 'center',
                                cursor: 'pointer',
                            }}
                        >
                            <input {...getInputProps()} />
                            <UploadFileOutlinedIcon fontSize="large" color="info" sx={{fontSize: "4rem !important"}} />
                            <MDTypography>Click to select files to upload</MDTypography>
                            <MDTypography>Or drag and drop here</MDTypography>
                        </Box>
                    )}
                </Dropzone>
                {
                    state.files.length > 0 ?
                        <MDBox className='documents' mt={2}>
                            {
                                state.files.map((file, index) => {
                                    return renderFile(file, index)
                                })
                            }
                        </MDBox>
                    :
                        null
                }
            </div>
        </MDModal>
    )
};

UploadModal.defaultProps = {
    folder: null
}
UploadModal.propTypes = {
    classes: PropTypes.object,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
    open: PropTypes.bool,
    folder: PropTypes.string,
    uploading: false
};

export default UploadModal;